import React, { useState } from 'react';

import CloseIcon from '../../../assets/images/icons/close.svg';
import './StageNotify.scss';

const StageNotify = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="stage-notify">
      <img className="stage-notify__close" src={CloseIcon} onClick={() => setIsVisible(false)} />
      <div className="stage-notify__title">Attention</div>
      <div className="stage-notify__message">This is a staging environment</div>
    </div>
  );
};

export default StageNotify;
